import { gql } from "@apollo/client";

export const termsAccepted = gql`
mutation updateTermsAccepted {
    updateTermsAccepted
    }
`;